module.exports = __webpack_public_path__ + "img/mark2_h.b31ebc75.png";